"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = theme => ({
  dateTimeRow: {
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    color: 'inherit',
    fontWeight: 600
  },
  dateContainer: {
    position: 'relative',
    boxSizing: 'border-box',
    width: 304,
    '&.displayTime': {
      width: 148
    }
  },
  dateValue: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    height: 36,
    width: '100%',
    backgroundColor: theme.calendar.mainBgColor,
    border: `1px solid ${theme.calendar.borderColor}`,
    borderRadius: 4,
    cursor: 'default',
    '&.error': {
      borderColor: theme.textField.error.borderColor
    },
    '& input': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
      fontFamily: 'inherit',
      color: 'inherit',
      position: 'absolute',
      left: 8,
      width: '100%',
      height: '100%',
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent'
    },
    '& span': {
      position: 'absolute',
      left: 14,
      top: 8,
      width: 'auto',
      color: 'inherit'
    }
  },
  timeContainer: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    width: 148,
    flexShrink: 0,
    marginLeft: 8
  },
  timeValue: {
    boxSizing: 'border-box',
    position: 'relative',
    display: 'flex',
    width: 70,
    height: 36,
    backgroundColor: theme.calendar.mainBgColor,
    border: `1px solid ${theme.calendar.borderColor}`,
    borderRadius: 4,
    '&.error': {
      borderColor: theme.textField.error.borderColor
    },
    '& input': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
      fontFamily: 'inherit',
      color: 'inherit',
      position: 'absolute',
      left: 13,
      width: '100%',
      height: '100%',
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent'
    },
    '& span': {
      position: 'absolute',
      left: 14,
      top: 8
    }
  },
  timeSeparator: {
    position: 'relative',
    textAlign: 'center',
    width: 4,
    marginLeft: 2,
    marginRight: 2
  },
  small: {
    width: 216,
    fontSize: 12,
    '& $dateTimeRow': {
      height: 28
    },
    '& $dateContainer': {
      width: 216,
      height: 28,
      '&.displayTime': {
        width: 104
      }
    },
    '& $dateValue': {
      width: '100%',
      height: 28,
      '& span': {
        top: 5,
        left: 12,
        width: 'auto'
      }
    },
    '& $timeContainer': {
      width: 104,
      height: 28
    },
    '& $timeValue': {
      height: 28,
      width: 48,
      '& span': {
        top: 5,
        left: 12,
        width: 32
      },
      '& input': {
        left: 11,
        right: 0,
        top: 0,
        bottom: 0,
        width: 32
      }
    }
  }
});
exports.default = _default;